import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

interface Reaction {
  id: string;
  emoji: string;
  x: number;
  timestamp: number;
}

const EMOJIS = ['❤️', '🔥', '👏', '😂', '😍', '🎉', '💯', '👍'];

export const LiveReactions = () => {
  const [reactions, setReactions] = useState<Reaction[]>([]);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setReactions(prev => 
        prev.filter(r => Date.now() - r.timestamp < 3000)
      );
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const sendReaction = (emoji: string) => {
    const newReaction: Reaction = {
      id: `${Date.now()}-${Math.random()}`,
      emoji,
      x: Math.random() * 80 + 10, // Random position between 10-90%
      timestamp: Date.now(),
    };
    
    setReactions(prev => [...prev, newReaction]);
    setShowPicker(false);
  };

  return (
    <>
      {/* Floating Reactions */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {reactions.map((reaction) => {
          const age = Date.now() - reaction.timestamp;
          const progress = age / 3000;
          const yOffset = progress * -100; // Move up
          const opacity = 1 - progress;
          const scale = 1 + progress * 0.5;

          return (
            <div
              key={reaction.id}
              className="absolute bottom-0 text-4xl"
              style={{
                left: `${reaction.x}%`,
                transform: `translateY(${yOffset}vh) scale(${scale})`,
                opacity,
                transition: 'all 0.1s linear',
              }}
            >
              {reaction.emoji}
            </div>
          );
        })}
      </div>

      {/* Reaction Picker */}
      <div className="fixed bottom-24 left-4 z-50 pointer-events-auto">
        {showPicker && (
          <div className="mb-2 bg-black/80 backdrop-blur-md rounded-2xl p-3 flex gap-2 animate-scale-in">
            {EMOJIS.map((emoji) => (
              <Button
                key={emoji}
                variant="ghost"
                size="icon"
                className="text-2xl hover:scale-125 transition-transform h-12 w-12"
                onClick={() => sendReaction(emoji)}
              >
                {emoji}
              </Button>
            ))}
          </div>
        )}
        
        <Button
          size="icon"
          className="h-14 w-14 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 shadow-2xl hover:scale-110 transition-transform border-2 border-white"
          onClick={() => setShowPicker(!showPicker)}
        >
          <span className="text-2xl">😊</span>
        </Button>
      </div>
    </>
  );
};
